/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Shopping_TitleInputs */

const en_recipe_shopping_title = /** @type {(inputs: Recipe_Shopping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to shopping list`)
};

const de_recipe_shopping_title = /** @type {(inputs: Recipe_Shopping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf die Einkaufsliste`)
};

/**
* | output |
* | --- |
* | "Add to shopping list" |
*
* @param {Recipe_Shopping_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_shopping_title = /** @type {((inputs?: Recipe_Shopping_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Shopping_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_shopping_title(inputs)
	return en_recipe_shopping_title(inputs)
});